export function formatPhone(phone: string): string {
  if (!phone) {
    return '-';
  }

  // If already formatted (e.g., contains '(', '-', or '.'), return as is
  if (/[()\-. ]/.test(phone)) {
    return phone;
  }

  // Clean non-digit characters
  const cleaned = phone.replace(/\D/g, '');

  // Check for 10-digit US number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  // Fallback if not valid
  return phone;
}
